import { OrderEnum } from '@/types/schema';

export enum Operator {
  EQUALS = 'equals',
  EQUAL = 'equal',
  NOT_EQUALS = 'notEquals',
  SET = 'set',
  NOT_SET = 'notSet',
  CONTAINS = 'contains',
  CONTAINS_NOT = 'containsNot',
  AND = 'and',
  OR = 'or',
  IN = 'in',
  DATERANGE = 'dateRange',
}

export enum Order {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

export interface LegacyFilter {
  dimension: string;
  operator: Operator;
  values: string[];
}

export interface Filter {
  operator: Operator;
  property?: string;
  value?: string | string[] | boolean[];
  filters?: Filter[];
}

export interface Sort {
  property: string;
  order: OrderEnum;
}

export interface TimeDimension {
  dimension: string;
  dateRange: [string, string];
}

export interface PaginationProps {
  first: number;
  after?: string;
  sortField: string;
  order: Order;
}

export interface ILegacyReporting {
  reportName: string;
  measures: string[];
  dimensions: string[];
  timeDimensions: TimeDimension[];
  filters: LegacyFilter[];
  paginationProps?: PaginationProps;
}

export interface IReportingWidget {
  name: string;
  payload: object;
}

export interface IReporting {
  entity: string;
  measures?: Measures[];
  dimensions?: string[];
  timeDimensions?: TimeDimension[];
  filters?: Filter[];
  projections?: string[];
  sortOrder?: Sort[];
  widget?: IReportingWidget;
  from?: number;
  size?: number;
  serviceableByGoReporting?: boolean;
}

export interface Measures {
  name: string;
  field: string;
  aggregator: string;
}
